import { IconAlarm } from '@assets/images/main/index';
import {
  CameraFunctions1D,
  CameraFunctions1M,
  CameraFunctions1T,
  CameraFunctions2D,
  CameraFunctions2M,
  CameraFunctions2T,
  CameraFunctions3D,
  CameraFunctions3M,
  CameraFunctions3T,
  CameraFunctions4D,
  CameraFunctions4M,
  CameraFunctions4T,
  CameraFunctions5D,
  CameraFunctions5M,
  CameraFunctions5T,
  CameraFunctions6D,
  CameraFunctions6M,
  CameraFunctions6T,
  CameraFunctions7D,
  CameraFunctions7M,
  CameraFunctions7T,
} from '@assets/images/main/camera/main/functions';
import { IconEdgeOff, IconEdgeOn, IconOsOff, IconOsOn, IconServerOff, IconServerOn } from '@assets/images/main/icon';
import {
  cameraBannerBg,
  cameraBannerProduct,
  cameraScreenshot1D,
  cameraScreenshot1M,
  cameraScreenshot1T,
  cameraScreenshot2D,
  cameraScreenshot2M,
  cameraScreenshot2T,
  cameraScreenshot3D,
  cameraScreenshot3M,
  cameraScreenshot3T,
} from '@assets/images/main/camera';
import { IconBlueCircle, IconBlueShield } from '@assets/images/main/icon/blue';
import { Icon3d3d, Icon3dCycle, Icon3dDetect, Icon3dMeter } from '@assets/images/icon';
import { screenViewCamera1, screenViewCamera2, screenViewCamera3, screenViewCamera4, screenViewCamera5 } from '@assets/images/main/screenView';

import { ReactComponent as SvgGridLine } from '@assets/images/icon/svg/grid-line.svg';
import { ReactComponent as SvgLocationLine } from '@assets/images/icon/svg/location-line.svg';
import { ReactComponent as SvgChartLine } from '@assets/images/icon/svg/chart-line.svg';
import { ReactComponent as SvgPencilLine } from '@assets/images/icon/svg/pencil-line.svg';
import { ReactComponent as SvgAi } from '@assets/images/icon/svg/ai.svg';

export default {
  mainPage: {
    product: {
      title: '查看产品组成',
      desc: '了解创新的视频定位产品。',
      outdoor: {
        title: '室外摄像头',
        desc: '通过摄像头可检测和管理<br/>人员、车辆等对象的位置和异常行为。',
      },
      indoor: {
        title: '室内摄像头',
        desc: '通过摄像头分析<br/>室内人员的移动路径。',
      },
    },
  },

  banner: {
    title: '仅凭视频实现实时定位追踪，<br/>自动跟踪人员和车辆的移动。',
    desc: '利用 AI Server 和 AI Edge，轻松追踪人员和车辆位置，<br/>并与 ORBRO OS 完美联动。',

    schemeTitle: 'ORBRO推荐的摄像头系统',
    schemeDesc: '需要决策支持？',
    schemeDesc2: '请联系<br/>我们的出入管理专家将为您提供帮助。',
    phone: '1522-9928',

    bgImg: cameraBannerBg,
    productImg: cameraBannerProduct,
  },

  bannerData: [
    {
      icon: IconEdgeOn,
      iconInv: IconEdgeOff,
      image: '',
      iconText: 'ORBRO Edge AI',
      sub: 'New',
      link: '/cn/camera/edge',
    },
    {
      icon: IconServerOn,
      iconInv: IconServerOff,
      image: '',
      iconText: 'ORBRO AI Server',
      sub: 'New',
      link: '/cn/camera/server',
    },
  ],
  screenView: {
    title: '实时视频连接带来的瞬间洞察',
    data: [
      { icon: SvgGridLine, text: '多路视频流', img: screenViewCamera1 },
      { icon: SvgLocationLine, text: '位置信息转换', img: screenViewCamera2 },
      { icon: SvgChartLine, text: '视频洞察分析', img: screenViewCamera3 },
      { icon: SvgPencilLine, text: '支持提示功能', img: screenViewCamera4 },
      { icon: SvgAi, text: '情境识别引擎', img: screenViewCamera5 },
    ],
  },
  screenShot: [
    {
      title: '无需标签，仅靠视频实现定位追踪',
      desc: '人员或车辆一旦被摄像头捕捉，其位置将实时显示在地图上。<br/>无需额外标签，通过视频识别对象并在平面图中可视化其位置。',
      img: {
        desktop: cameraScreenshot1D,
        tablet: cameraScreenshot1T,
        mobile: cameraScreenshot1M,
      },
    },
    {
      title: '无需重新安装摄像头',
      desc: '若现有摄像头支持 RTSP 或 ONVIF 协议，即可直接接入 AI 视频追踪功能。<br/>设置简单，并可为每个摄像头配置独立的识别模型。',
      img: {
        desktop: cameraScreenshot2D,
        tablet: cameraScreenshot2T,
        mobile: cameraScreenshot2M,
      },
    },
    {
      title: 'AI 解析空间中的“行为”并提供提示',
      desc: 'AI 理解现场情况并提供分析结果。<br/>可识别危险事件、工作状态、出入异常等，自动化执行安防任务。',
      img: {
        desktop: cameraScreenshot3D,
        tablet: cameraScreenshot3T,
        mobile: cameraScreenshot3M,
      },
    },
  ],

  video: {
    title: 'ORBRO 人工智能摄像头系统',
    desc: [
      { text: '收集并分析室外空间中车辆与人员的位置数据。' },
      { text: '识别室内人员的移动路径。' },
      { text: '可与现有的公共监控摄像头（如CCTV）系统对接。' },
      { text: '可根据需要灵活添加新摄像设备。' },
    ],
  },

  func: {
    title: '查看摄像头功能',
    desc: '了解摄像系统的多样化功能。',

    data: [
      {
        img: IconBlueShield,
        title: '权限与群组管理',
        desc: '区分管理员与用户权限，按角色控制功能访问。\n支持按部门或团队进行群组设置。',
      },
      {
        img: IconAlarm,
        title: '条件告警设置（五级）',
        desc: '可根据预设条件设置五级告警。\n帮助快速识别异常并及时响应。',
      },
      {
        img: Icon3dMeter,
        title: '区域监控（Zone）',
        desc: '可在地图上直接设置监控区域，实时追踪进入该区域的人员或资产。',
      },
      {
        img: Icon3dCycle,
        title: '逆行检测',
        desc: '系统自动检测与设定路径方向相反的行为并发出警告。',
      },
      {
        img: Icon3dDetect,
        title: '出入检测（In/Out Zone）',
        desc: '自动识别进出区域的人员活动。\n可分析进出记录与停留时间。',
      },
      {
        img: Icon3d3d,
        title: '设备搜索与状态管理',
        desc: '集中管理大量标签与锚点设备，包括电量与连接状态。',
      },
    ],
  },

  functions: {
    title: '基于AI的数字孪生定位追踪技术',
    desc: 'ORBRO的AI摄像头系统具备高精度与高稳定性。<br/>可在室内外准确识别并分析人车位置，提供有价值的数据。',

    line: 3,
    card: [
      {
        size: '3',
        tag: '核心功能',
        title: '视频检测的对象<br/>实时呈现在地图上',
        label: '管理员',
        img: {
          desktop: CameraFunctions1D,
          tablet: CameraFunctions1T,
          mobile: CameraFunctions1M,
        },
      },
      {
        color: '#fff',
        size: '1',
        tag: '移动服务',
        title: '适用于各类空间，<br/>具备移动端兼容性',
        label: '通用',
        img: {
          desktop: CameraFunctions2D,
          tablet: CameraFunctions2T,
          mobile: CameraFunctions2M,
        },
      },
      {
        size: '2',
        tag: '兼容旧有CCTV',
        title: '支持所有视频数据，<br/>全面兼容',
        label: '管理员',
        img: {
          desktop: CameraFunctions3D,
          tablet: CameraFunctions3T,
          mobile: CameraFunctions3M,
        },
      },
      {
        size: '2',
        tag: '人员/车辆识别',
        title: '高识别率，<br/>支持人车检测',
        label: '管理员',
        img: {
          desktop: CameraFunctions4D,
          tablet: CameraFunctions4T,
          mobile: CameraFunctions4M,
        },
      },
      {
        size: '2',
        tag: '本地服务器部署',
        title: '最可靠、<br/>最稳定的安防体系',
        label: '本地部署',
        img: {
          desktop: CameraFunctions5D,
          tablet: CameraFunctions5T,
          mobile: CameraFunctions5M,
        },
      },
      {
        size: '1',
        tag: '适用于大型户外停车场等',
        title: '适用于大规模停车设施<br/>的系统部署',
        label: '企业级',
        img: {
          desktop: CameraFunctions6D,
          tablet: CameraFunctions6T,
          mobile: CameraFunctions6M,
        },
      },
      {
        size: '3',
        tag: '数据仪表盘',
        title: '数据洞察力，<br/>基于数据的决策支持',
        label: '管理员',
        img: {
          desktop: CameraFunctions7D,
          tablet: CameraFunctions7T,
          mobile: CameraFunctions7M,
        },
      },
    ],
  },

  FAQ: [
    {
      title: 'ORBRO的视频定位系统是如何工作的？',
      description: '系统通过安装的摄像头采集视频，AI实时识别人或车辆的位置。<br/>计算结果将在 ORBRO OS 中以地图方式可视化显示。',
    },
    {
      title: 'ORBRO Edge AI 和 AI Server 有什么不同？',
      description: 'ORBRO Edge AI 是一体化设备，可独立完成 AI 分析与定位计算。<br/>AI Server 可集中分析多个摄像头的视频数据，需搭配 ORBRO Server 使用。',
    },
    {
      title: '可以与已有CCTV摄像头配合使用吗？',
      description: '可以。支持 RTSP 或 ONVIF 协议的摄像头均可集成。',
    },
    {
      title: '不使用服务器也能运行吗？',
      description: 'ORBRO Edge AI 可在无服务器的情况下独立运行。<br/>但 AI Server 需与 ORBRO Server 配合使用。',
    },
    {
      title: '视频定位比 BLE/UWB 更好吗？',
      description: '这取决于使用场景。<br/>视频定位无需标签但有视野限制，<br/>而无线定位不受视野限制但需使用标签。<br/>ORBRO 支持两者组合使用。',
    },
    {
      title: '视频数据会被保存吗？隐私是否有保障？',
      description: '系统默认仅分析视频，不保存视频内容，仅记录定位信息。<br/>如需保存视频，也可启用加密与访问权限控制功能。',
    },
    {
      title: '只能检测人吗？',
      description: '默认识别人，也可通过设置识别车辆、设备、防护装备（如安全帽）等对象。',
    },
    {
      title: '可以接收实时告警吗？',
      description: '可以。<br/>可根据设置条件（如进入区域、未检测）实时向管理员发送通知（推送、邮件、Webhook 等）。',
    },
  ],
};
